import { $host } from "./fetch"


export const getAll = async () => {
    const { data } = await $host.post(
       'payment/getAll'
    )

    return data
}